const sortRowsAlphabetically = (rows, getValue, order) =>
  [...rows].sort((a, b) => {
    const valueA = String(getValue(a) || "").toLowerCase();
    const valueB = String(getValue(b) || "").toLowerCase();

    return order === "asc"
      ? valueA.localeCompare(valueB)
      : valueB.localeCompare(valueA);
  });

export default sortRowsAlphabetically;
